import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
	routes: [
		{path: '/',redirect:'index'},
		{path: '/index',component:()=>import("./pages/index.vue"),name:"首页"},
		{path: '/login',component:()=>import("./pages/login.vue"),name:"登录"},
		{path: '/collect',component:()=>import("./pages/collect.vue"),name:"玩家集结"},
		{path: '/task-guide',component:()=>import("./pages/task-guide.vue"),name:"任务说明"},
		{path: '/training-agenda',component:()=>import("./pages/training-agenda.vue"),name:"培训议程"},
		{path: '/task-checkin',component:()=>import("./pages/task-checkin.vue"),name:"任务打卡"},
		{path: '/points-ranking',component:()=>import("./pages/points-ranking.vue"),name:"积分排行"},
		{path: '/wechat-moments',component:()=>import("./pages/wechat-moments.vue"),name:"朋友圈"},
		{path: '/checkin',component:()=>import("./pages/checkin.vue"),name:"签到打卡"},
		{path: '/photo-album',component:()=>import("./pages/photo-album.vue"),name:"相册"},
		{path: '/files',component:()=>import("./pages/files.vue"),name:"会议资料"},
		
	]
})